






























































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetPaperDetail } from "@/request/common";
@Component({})
export default class Name extends Vue {
  private data: any = {};
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPaperDetail(this, this.data.id, loading).then((res: any) => {
      this.data = res.data;
    });
  }
  private mounted() {
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getData();
    }
  }
}
